module.exports = __webpack_public_path__ + "img/sps-logo.png";